<div
  *ngFor="let alert of alerts.alerts"
  class="alert alert-{{ alert.type }}"
  role="alert"
  (click)="getComponent($event, alert)">
  {{ alert.message | parseHtmlContent }}
</div>
